export default "__VITE_ASSET__a302bbb1__"